import { SessionModel } from '@/models/auth/session';
import { SessionRGOModel } from '@/models/auth/session-rgo';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import moment from 'moment';

/**
 *
 * This Auth serializer is responsible for converting the Raw format to model.
 *
 */
export class AuthSerializer {
         private static INSTANCE = new AuthSerializer();

         static get instance() {
           return this.INSTANCE;
         }

        // Vuejs session serializer
         public sessionModelSerializer(res: any, accessToken?: string) {
           const result: SessionModel = {
             access_token: res.access_token || accessToken,
             access_token_validity: res.access_token_validity,
             cdn_urls: res.cdn_urls,
             provided_at: res.provided_at,
             user_id: res.user_id,
             username: res.username,
             email: res.email,
             first_name: res.first_name,
             last_name: res.last_name,
             user_category: res.user_category,
             thumbnail: res.thumbnail,
             tenant: res.tenant,
             thumbnail_url: this.getThumbnailUrl(res),
             user_display_name: this.getUserDisplayName(res),
             permissions: res.permissions,
             isShareableLink: res.isShareableLink,
             accessPath: res.accessPath,
             isHideRoleMenu: res.isHideRoleMenu,
           };
           return result;
         }

         public uploadModelItemsSerializer(res: any) {
           const result = {
             contentIngestItems: res.contentIngestItems.map((data: any) => {
              const item: any = JSON.parse(data.row_data);
              return {
                 uniqueId: item.UniqueId,
                 validationFailedReason: data.validation_failed_reason,
               };
             }),
             count: res.count,
           };
           return result;
         }

         public uploadModelSerializer(res: any) {
           const result = {
             contentIngestRequests: res.contentIngestRequests.map(
               (data: any) => {
                 return {
                   name: data.file_display_name,
                   id: data.id,
                   status: data.status,
                   uploadDate: moment
                     .utc(data.uploaded_at)
                     .local()
                     .format('DD/MM/YYYY HH:mm A'),
                   resourceCount: data.records_count > 0 ? data.records_count : '-' ,
                   processCount: data.records_count - data.validation_failed_count,
                   errorCount: data.validation_failed_count,
                   jobId: data.job.id,
                 };
               },
             ),
             count: res.count,
           };
           return result;
         }

        // Emberjs session serializer
         public sessionModelRGOSerializer(res: any) {
           const result: SessionRGOModel = {
             authenticated: {
               'authenticator': 'authenticator:auth-api-3',
               'token-api3': res.access_token,
               'token': '0e22e273-e2aa-4a6e-9e4f-c4d376c5317b',
               'tenant': {
                 tenantId: res.tenant.tenant_id,
                 settings: res.tenant.settings,
               },
               'user': {
                 username: res.username,
                 gooruUId: res.user_id,
                 isNew: false,
                 avatarUrl: this.getThumbnailUrl(res),
                 userDisplayName: res.user_display_name,
                 role: 'teacher',
               },
               'cdnUrls': {
                 user: res.cdn_urls.user_cdn_url,
                 content: res.cdn_urls.content_cdn_url,
               },
               'isAnonymous': false,
               'permissions': res.permissions,

             },
           };
           return result;
         }

         private getThumbnailUrl(res: any) {
           let thumbnailUrl: string = '';
           if (res.thumbnail) {
             thumbnailUrl = (res.cdn_urls.user_cdn_url + res.thumbnail);
           } else {
             thumbnailUrl = DEFAULT_IMAGES_PATH.profile;
           }
           return thumbnailUrl;
         }

         private getUserDisplayName(res: any) {
           let userDisplayName: string = '';
           if (res.first_name) {
             userDisplayName = res.first_name;
             if (res.last_name) {
               userDisplayName += ` ${res.last_name}`;
             }
           } else if (res.username) {
             userDisplayName = res.username;
           } else if (res.email) {
             userDisplayName = res.email.split('@')[0];
           }
           return userDisplayName;
         }

        }

export const authSerializer = AuthSerializer.instance;
